import { mapState, mapActions } from 'vuex'
import util from '@/util'
import mensagens from '@/util/mensagens'
import { BToast, BSpinner } from 'bootstrap-vue'
import PainelAcesso from '@/components/layout/painelAcesso/PainelAcesso.vue'
import Endereco from '@/components/layout/endereco/Endereco.vue'
import { faturaMixin } from '@/modules/faturas/mixins'
import FormularioCredito from '@/components/layout/pagamento/FormularioCredito.vue'
import { validarCampos } from '@/util/validacaoUtil'
import constants from '@/util/constants'

export default {
  name: 'pagamentoOferta',
  components: {
    'b-toast': BToast,
    'b-spinner': BSpinner,
    PainelAcesso,
    Endereco,
    FormularioCredito
  },
  props: {
    flags: {
      type: Object,
      required: true
    },
    oferta: {
      type: Object,
      required: true
    }
  },
  mixins: [faturaMixin],
  computed: {
    ...mapState('auth', ['regrasLogin']),
    desabilitarCampos () {
      return this.flagsDeControle.manipulandoDados.status || this.flagsDeControle.carregandoDados.status
    },
    planoOfertado: {
      get () {
        return this.oferta.desconto
      }
    },
    planoOfertadoEhMensal () {
      return this.planoOfertado.plano_tipo === constants.tipoPlano.mensal
    }
  },
  data: () => {
    return {
      formulario: {
        cartao: {
          numero: null,
          nome: null,
          bandeira: null,
          validade: null,
          ccv: null
        }
      },
      bandeiraDoCartao: null,
      flagsDeControle: {
        manipulandoDados: {
          status: false,
          mensagem: ''
        },
        carregandoDados: {
          status: false,
          mensagem: ''
        }
      },
      retorno: {
        sucesso: false,
        mensagem: '',
        listaDeErros: []
      }
    }
  },
  async mounted () {
  },
  methods: {
    ...mapActions('auth', ['ActionSetRegrasLogin']),
    obterBandeiraInputLocal (bandeira) {
      return this.obterIconeBandeira(bandeira)
    },
    determinarBandeiraDoCartao (event) {
      const numero = event.target.value.trim().replace(/\s+/g, '')
      const filtroPorNumeroCartao = (numero, bandeira) => bandeira.regex.test(numero)
      const bandeiraEncontrada = this.obterBandeiraCartaoPorFiltro(numero, filtroPorNumeroCartao)
      this.formulario.cartao.bandeira = bandeiraEncontrada?.nome
    },

    tratarDadosAntesEnvio (dados) {
      const { cartao } = { ...dados }
      cartao.numero = util.apenasNumeros(cartao.numero)
      const payload = { cartao: cartao, oferta_id: this.oferta.id }
      return payload
    },

    async confirmar () {
      const dadosValidos = this.validarCampos(this.formulario)
      if (!dadosValidos) {
        return
      }
      this.definirFlagManipulandoDados(true, mensagens.salvandoDadosCadastro)
      try {
        const payload = this.tratarDadosAntesEnvio(this.formulario)
        const resposta = await this.axios.post('manager/ofertas/boas-vindas/pagar', payload)
        this.retorno.sucesso = resposta.data.retorno.sucesso
        this.retorno.mensagem = resposta.data.retorno.mensagem
        this.retorno.listaDeErros = resposta.data.retorno.listaDeErros
        if (this.retorno.sucesso === true) {
          this.emitirEventoFinalizacaoPagamento()
          return
        } else {
          this.emitirEventoNotificacao(this.retorno.mensagem)
        }
      } catch (e) {
        util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaServidorSalvandoDados)
      } finally {
        this.definirFlagManipulandoDados(false, '')
      }
    },

    async voltar () {
      this.resetarDadosRetorno()
      this.definirFlagManipulandoDados(true, mensagens.salvandoDadosCadastro)
      try {
        this.flags.pagamentoOfertaPendente = false
        const pendenciasLogin = JSON.parse(this.regrasLogin)
        pendenciasLogin.ofertaBoasVindasPendente = true
        this.ActionSetRegrasLogin(JSON.stringify(pendenciasLogin))
      } catch (e) {
        util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaServidorSalvandoDados)
      } finally {
        this.definirFlagManipulandoDados(false, '')
      }
    },

    emitirEventoNotificacao (mensagem) {
      const contemErroEndereco = Object.keys(this.retorno.listaDeErros).some(chave => chave.includes('endereco'))
      if (!contemErroEndereco) {
        util.criarAlertaToastDeErro(this, 'Aviso', this.retorno.mensagem)
        return
      }

      this.$emit('enviarNotificacao', this.retorno.listaDeErros, mensagem)
    },

    validarCampos (dadosEmpresa) {
      const campos = [
        {
          campo: 'cartao.numero',
          validacoes: [
            { mensagem: 'Esse campo é obrigatório.', validar: valor => !util.valorVazio(valor) }
          ]
        },
        {
          campo: 'cartao.nome',
          validacoes: [
            { mensagem: 'Esse campo é obrigatório.', validar: valor => !util.valorVazio(valor) }
          ]
        },
        {
          campo: 'cartao.validade',
          validacoes: [
            { mensagem: 'Esse campo é obrigatório.', validar: valor => !util.valorVazio(valor) }
          ]
        },
        {
          campo: 'cartao.ccv',
          validacoes: [
            { mensagem: 'Esse campo é obrigatório.', validar: valor => !util.valorVazio(valor) }
          ]
        }
      ]
      const validacao = validarCampos(campos, dadosEmpresa)
      this.retorno.listaDeErros = { ...validacao.listaDeErros }
      this.retorno.sucesso = !validacao.erro
      const dadosValidos = !validacao.erro
      return dadosValidos
    },
    resetarDadosRetorno () {
      this.retorno.sucesso = false
      this.retorno.mensagem = ''
      this.retorno.listaDeErros = []
    },
    emitirEventoFinalizacaoPagamento () {
      this.$emit('finalizandoPagamento')
    },

    definirFlagManipulandoDados (status, mensagem) {
      this.flagsDeControle.manipulandoDados.status = status
      this.flagsDeControle.manipulandoDados.mensagem = mensagem
    },

    definirFlagCarregandoDados (status, mensagem) {
      this.flagsDeControle.carregandoDados.status = status
      this.flagsDeControle.carregandoDados.mensagem = mensagem
    }
  }
}
